import { RGBAColor } from "../types";

export const maxColor: RGBAColor = {
  r: 188,
  g: 255,
  b: 2,
};

export const completeColor: RGBAColor = {
  r: 85,
  g: 185,
  b: 56,
};

export const middleColor: RGBAColor = {
  r: 255,
  g: 217,
  b: 2,
};

export const minColor: RGBAColor = {
  r: 229,
  g: 80,
  b: 0,
};

export function generatePercentColor(ratio: number): RGBAColor {

  if (ratio <= 0.3) {
    return minColor;
  } else if (ratio <= 0.6) {
    // Интерполяция между minColor и middleColor
    const t = (ratio - 0.3) / 0.3;
    return {
      r: Math.round(minColor.r + (middleColor.r - minColor.r) * t),
      g: Math.round(minColor.g + (middleColor.g - minColor.g) * t),
      b: Math.round(minColor.b + (middleColor.b - minColor.b) * t),
    };
  } else if (ratio <= 1) {
    // Интерполяция между middleColor и completeColor
    const t = (ratio - 0.6) / 0.4;
    return {
      r: Math.round(middleColor.r + (completeColor.r - middleColor.r) * t),
      g: Math.round(middleColor.g + (completeColor.g - middleColor.g) * t),
      b: Math.round(middleColor.b + (completeColor.b - middleColor.b) * t),
    };
  } else if (ratio <= 1.2) {
    // Интерполяция между completeColor и maxColor
    const t = (ratio - 1) / 0.2;
    return {
      r: Math.round(completeColor.r + (maxColor.r - completeColor.r) * t),
      g: Math.round(completeColor.g + (maxColor.g - completeColor.g) * t),
      b: Math.round(completeColor.b + (maxColor.b - completeColor.b) * t),
    };
  } else {
    return maxColor;
  }
}
